import cx from "classnames";
import { Icon } from "common/LegacyIcon";
import { CircleSpinner } from "common/spinners";
import { commonCTAs } from "lib/localization";
import * as urlHelpers from "lib/urlHelpers";
import _ from "lodash";
import React from "react";
import { BottomBar } from "./BottomBar";
import styles from "./MainPhoto.scss";

export class MainPhoto extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cacheBuster: "",
      rotating: false,
      spinner: true,
      barPadding: 0,
      layout: {},
      layoutPending: true,
    };
    this.onResize = _.throttle(this.doLayout, 30);
  }

  componentDidMount() {
    window.addEventListener("resize", this.onResize);
  }

  UNSAFE_componentWillReceiveProps({ activePhoto, photos }) {
    // eslint-disable-line
    if (photos.get(activePhoto).id !== this.props.photos.get(this.props.activePhoto).id) {
      this.setState({ layoutPending: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize);
  }

  onRotate = () => {
    this.setState({ rotating: true, spinner: true });
  };

  onRotateComplete = () => {
    const cacheBuster = "?" + Math.random().toString(36).substr(7);
    this.setState({ cacheBuster, rotating: false });
  };

  onLoad = () => {
    this.setState({ spinner: false });
    this.doLayout();
  };

  doLayout = () => {
    // do the main layout in JS because flexbox isn't quite powerful enough
    // see https://cloud.githubusercontent.com/assets/347189/19745439/754fa1b2-9b86-11e6-9ac8-4731015fe4a0.jpg
    // for where these calculations come from
    const K = this._container.clientHeight;
    const W = this._container.clientWidth;
    const jMin = 50;
    const pMin = 80;
    const mMin = 40;
    // aspect ratio of the image
    const a = this._img.naturalWidth / this._img.naturalHeight;
    // ratio of the available space to display the image
    const s = (W - 2 * jMin) / (K - mMin - pMin);
    // y = final image height
    // x = final image width
    // p = stageTop height
    // m = stageBottom height
    let y, x, p, m;
    if (s > a) {
      y = K - mMin - pMin;
      x = y * a;
      p = pMin;
      m = mMin;
    } else {
      x = W - 2 * jMin;
      y = x / a;
      p = (K - y) / 2;
      m = K - y - p;
      if (p < pMin) {
        p = pMin;
      }
    }
    this.setState({ layout: { x, y, p, m }, layoutPending: false });
  };

  setContainer = (container) => {
    this._container = container;
  };

  setImg = (img) => {
    this._img = img;
  };

  render() {
    const {
      photos,
      activePhoto,
      next,
      prev,
      readonly,
      onCaptionChange,
      photosetId,
      parentType,
      parentId,
      coverId,
      onSetCover,
      intl,
    } = this.props;
    const { cacheBuster, rotating, spinner, layout, layoutPending } = this.state;
    const photo = photos.get(activePhoto);
    const src = urlHelpers.photoLarge(photo.id) + cacheBuster;

    return (
      <div className={styles.MainPhoto} ref={this.setContainer}>
        <div className={styles.prev} onClick={prev}>
          <Icon i="leftChevron" title={intl.formatMessage(commonCTAs.back)} size={30} />
        </div>
        <div className={styles.stage} style={{ width: layout.x }}>
          <div className={styles.stageTop} style={{ minHeight: layout.m }} />
          {!rotating && (
            <img
              src={src}
              style={{
                width: layout.x,
                height: layout.y,
                minWidth: layout.x,
                minHeight: layout.y,
              }}
              className={cx(styles.photo, layoutPending && styles.layoutPending)}
              onClick={next}
              onLoad={this.onLoad}
              ref={this.setImg}
            />
          )}
          {spinner && (
            <div className={styles.spinner}>
              <CircleSpinner size={40} />
            </div>
          )}
          <div className={styles.stageBottom} style={{ minHeight: layout.p }}>
            {!rotating && (
              <BottomBar
                intl={intl}
                readonly={readonly}
                photo={photo}
                key={`${photo.id}-caption`}
                onRotate={this.onRotate}
                onRotateComplete={this.onRotateComplete}
                onCaptionChange={onCaptionChange}
                onDelete={this.props.onDelete}
                rotating={rotating}
                photosetId={photosetId}
                parentType={parentType}
                parentId={parentId}
                coverId={coverId}
                onSetCover={onSetCover}
              />
            )}
          </div>
        </div>
        <div className={styles.next} onClick={next}>
          <Icon i="rightChevron" title={intl.formatMessage(commonCTAs.next)} size={30} />
        </div>
      </div>
    );
  }
}
